<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="英語化問診票作成： 翻訳内容を確認"
        hide-footer
        @hidden="close">
        <div
            v-if="user === null || transProfile === null || transAnswers === null"
            class="d-flex justify-content-center align-items-center pt-5 pb-5">
            <b-spinner variant="yokumiru-user"></b-spinner>
        </div>
        <div v-else class="mb-3">
            <div class="mb-3">自動翻訳を行いました。翻訳結果を確認し、必要に応じて修正を行ってください。</div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">セイ</label>
                        <input
                            :value="transProfile.last_name_kana_en"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'last_name_kana', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.last_name_kana }}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">メイ</label>
                        <input
                            :value="transProfile.first_name_kana_en"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'first_name_kana', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.first_name_kana }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">生年月日</label>
                        <input
                            :value="transProfile.birthday_en"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'birthday', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.birthday }}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">性別</label>
                        <input
                            :value="transProfile.sex_en"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'sex', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.sex ? '女性' : '男性' }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">身長</label>
                        <input
                            :value="transProfile.height_en || '-'"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'height', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.height || '-' }}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">体重</label>
                        <input
                            :value="transProfile.weight_en || '-'"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'weight', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.weight || '-' }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">血液型</label>
                        <input
                            :value="transProfile.blood_en || '-'"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'blood', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.blood || '-' }}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="mb-0">体温</label>
                        <input
                            :value="transProfile.body_temperature_en || '-'"
                            type="text"
                            class="form-control customFormControl"
                            disabled>
                        <b-button
                            variant="yokumiru-gray"
                            size="sm"
                            class="customFormBtn"
                            @click="onClickBtnProfile(transProfile, 'body_temperature', $event)">
                            修正
                        </b-button>
                        <div class="text-muted small pt-1 pl-1">{{ transProfile.body_temperature || '-' }}</div>
                    </div>
                </div>
            </div>

            <div v-for="(a, idx) in transAnswers">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label class="mb-0">{{ a.title }}</label>
                            <div class="mb-3">
                                <div
                                    type="text"
                                    class="form-control customFormControl pseudoFormControl"
                                    :id="`a-${a.id}`">{{ a.content_en }}</div>
                                <b-button
                                    variant="yokumiru-gray"
                                    size="sm"
                                    class="customFormBtn"
                                    @click="onClickBtnAnswer(a, $event)">
                                    修正
                                </b-button>
                                <div class="text-muted small pt-1 pl-1">{{ a.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center">
                <div class="ml-2 mr-2">
                    <b-button
                        class="prevButton"
                        :disabled="inProgress"
                        @click="close">
                        戻る
                    </b-button>
                </div>
                <div class="ml-2 mr-2">
                    <b-button
                        class="nextButton"
                        :disabled="inProgress"
                        @click="handleOk">
                        翻訳内容を確定
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                modalShow: false,
                user: null,
                bodyTemperature: null,
                medicalCourse: null,
                transProfile: null,
                transAnswers: null,
                questionTypes: constants.interview_question_types,
                errors: {},
            }
        },

        created: function() {
            bus.$on('open-modal-user-interview-trans-answers', this.open)
            bus.$on('user-interview-trans-answer-modified', this.modifyAnswer)
            bus.$on('user-interview-trans-profile-modified', this.modifyProfile)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-user-interview-trans-answers')
            bus.$off('user-interview-trans-answer-modified')
            bus.$off('user-interview-trans-profile-modified')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
                this.user = this.$store.state.userInterviewTransAnswers.user
                this.medicalCourse = this.$store.state.userInterviewTransAnswers.medicalCourse
                this.transProfile = this.$store.state.userInterviewTransAnswers.transProfile
                this.transAnswers = this.$store.state.userInterviewTransAnswers.transAnswers
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 修正ボタン押下時（プロフィール）
             * @param {object} transProfile
             * @param {string} key
             * @param {object} e
             */
            onClickBtnProfile: function (transProfile, key, e) {
                e.preventDefault()
                bus.$emit('open-modal-user-interview-trans-modification', {
                    key: key,
                    transProfile: transProfile,
                    transAnswer: null,
                })
            },

            /**
             * 修正ボタン押下時（回答）
             * @param {object} transAnswer
             * @param {object} e
             */
            onClickBtnAnswer: function (transAnswer, e) {
                e.preventDefault()
                bus.$emit('open-modal-user-interview-trans-modification', {
                    key: null,
                    transProfile: null,
                    transAnswer: transAnswer,
                })
            },

            /**
             * 「翻訳内容を確定」ボタン押下時
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()
                bus.$emit('open-modal-user-interview-trans-completed')
            },

            /**
             * 問診回答の修正内容を反映
             * @param {object} answer
             */
            modifyAnswer: function (answer) {
                const idx = this.transAnswers.findIndex((transAnswer) => {
                    return transAnswer.id === answer.id
                })
                this.transAnswers[idx].content = answer.content
                this.transAnswers[idx].content_en = answer.content_en
            },

            /**
             * プロフィールの修正内容を反映
             * @param {object} profile
             */
            modifyProfile: function (profile) {
                this.transProfile = profile
            },
        },
    }
</script>

<style lang="scss" scoped>
.prevButton,
.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.prevButton {
    color: #333;
    background-color: #D9D9D9;
}

.row .col .form-group .customFormControl {
    position: relative;
    background: transparent;
    border: none;
    border-bottom: 1px solid #333;
    border-radius: 0;
    padding-left: 0;
    padding-right: 60px;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;

    &.pseudoFormControl {
        height: auto;
    }
}

.customFormBtn {
    width:50px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-75%);
}
</style>
